import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Controller } from "react-hook-form";
import CalendarIcon from "assets/svg/dateForm.svg";
import Image from "next/image";
import { format, parse } from "date-fns";
import { useTranslation } from "react-i18next";
import useResponsiveLanguage from "@/utils/useResponsiveLanguage";
type PropsType = {
  control?: any;
  name?: string;
  watch?: any;
  errors?: any;
  required?: boolean;
  register?: any;
  label?: string;
  onChange?: any;
  minDate?: boolean;
  startFrom?: Date;
  disabled?: boolean;
  setValue?: any;
  getValues?: any;
};

const DateInput: React.FC<PropsType> = ({
  control,
  name,
  watch,
  errors,
  label,
  onChange,
  minDate = false,
  startFrom = "",
  disabled = false,
  setValue,
  getValues,
  required = false,
}) => {
  const { i18n } = useTranslation();
  const validationStyle = () => {
    if (errors && errors[name]) {
      return "ring-red-600 ring-2";
    } else {
      return "";
    }
  };

  const responseiveIconDirectionIcon = () => {
    if (i18n.language === "ar") {
      return "right-2.5 top-2.5 rounded-r-xl";
    } else if (i18n.language === "en") {
      return "left-2.5 top-1.5 rounded-l-xl";
    } else {
      return "right-2.5  rounded-r-xl";
    }
  };
  const responseiveIconDirection = () => {
    if (i18n.language === "ar") {
      return "pr-10";
    } else if (i18n.language === "en") {
      return "pl-10";
    } else {
      return "";
    }
  };
  const ExampleCustomInput = ({ name, watch, onClick, value }) => (
    <>
      <div className="flex flex-col w-full" onClick={onClick}>
        <div
          className={`${
            disabled ? "opacity-30 " : ""
          }relative flex items-center w-full h-[35px] mt-2 mb-3 group`}
        >
          <label
            className={`absolute ${responseiveIconDirection()} capitalize group-hover:-translate-y-3 px-3 text-sm font-normal transition-all duration-300 text-old-silver ${
              watch()[name] ? "-translate-y-2.5" : ""
            }`}
          >
            {label ? label : name}
          </label>
          <input
            type={"text"}
            disabled={true}
            value={value}
            className={`w-full pt-3 h-full px-3 ${responseiveIconDirection()}  text-base ${
              disabled ? "cursor-not-allowed" : "cursor-pointer"
            } font-bold outline-none appearance-none bg-[#F7F7F7] rounded-md text-[#585757] ${validationStyle()} `}
          />
          <div
            className={`absolute ${
              disabled ? "cursor-not-allowed" : "cursor-pointer"
            }  ${responseiveIconDirectionIcon()}`}
          >
            <Image width="20" height="20" src={CalendarIcon} alt="calendar" />
          </div>
          {!disabled && getValues(name) && (
            <div
              className={`cursor-pointer font-bold bg-main h-4 text-[0.50rem]  w-4 absolute ${
                i18n.language === "en" ? "right-1" : "left-1"
              } flex items-center justify-center rounded-full text-white pt-[0.08rem]`}
              onClick={() => setValue(name, null)}
            >
              X
            </div>
          )}
        </div>
      </div>
    </>
  );

  const NoClickInput = ({ ...props }) => {
    const { ExampleCustomInput } = props;

    return <ExampleCustomInput {...props} />;
  };
  const { responsivelanguage } = useResponsiveLanguage();
  return (
    <Controller
      control={control}
      name={name}
      rules={{ required: true }}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState,
      }) => {
        return (
          <div className={`w-full `}>
            <DatePicker
              minDate={minDate === true ? startFrom : null}
              placeholderText="Select date"
              clearIconStyle="left-0 "
              onChange={(date) => {
                if (date) {
                  let formatDate = format(date, "yyyy-MM-dd");

                  onChange(formatDate);
                } else {
                  onChange(null);
                }
              }}
              ref={ref}
              disabled={disabled}
              required={required}
              selected={value ? parse(value, "yyyy-MM-dd", new Date()) : null}
              name={name}
              onBlur={onBlur}
              {...fieldState}
              rtl={responsivelanguage(true, false)}
              customInput={
                <NoClickInput
                  name={name}
                  value={value}
                  watch={watch}
                  ref={ref}
                  ExampleCustomInput={ExampleCustomInput}
                />
              }
              isClearable={true}
              defaultValue={new Date()}
            />
          </div>
        );
      }}
    />
  );
};
export default DateInput;
